/**
 * A file dropped where nothing accepts it makes the browser open the file in
 * place of Mux. Drop targets cancel their own events first; anything left is
 * refused here. Editable fields keep native drops, such as Safari text drags,
 * which also carry a file.
 */
export function installFileDropGuard(target: Document) {
  const refuse = (event: DragEvent) => {
    const transfer = event.dataTransfer
    if (event.defaultPrevented || !transfer?.types.includes("Files")) return
    const element = event.target
    if (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement) return
    if (element instanceof HTMLElement && element.isContentEditable) return
    event.preventDefault()
    transfer.dropEffect = "none"
  }
  target.addEventListener("dragover", refuse)
  target.addEventListener("drop", refuse)
  return () => {
    target.removeEventListener("dragover", refuse)
    target.removeEventListener("drop", refuse)
  }
}
